import React from "react";
import Header from "../../../components/header";
import { withStyles } from "@mui/styles";
import { Box, Dialog, Typography } from "@mui/material";
import { useStyles } from "../indexFormStyles";
import { MESSGAE_IFRAME_LOADER_CONTENT } from "../../../constants";

const ProductCalculator = ({
  classes: { iframeContainer, iframeLoadingContent },
  calculatorPopup,
  handleClose,
  iframeSrc,
  loading,
  setLoading,
}) => {
  return (
    <Dialog
      aria-labelledby="simple-dialog-title"
      fullScreen={true}
      fullWidth={true}
      onClose={handleClose}
      open={calculatorPopup}
      maxWidth={"lg"}
    >
      <Header onClick={() => {}} title={""} isBackButtonVisible={false} />

      <Box mb={2}>
        <Box
          display="flex"
          justifyContent="center"
          sx={{ position: "relative" }}
        >
          <Box className={iframeContainer}>
            {loading && (
              <Box className={iframeLoadingContent}>
                <Typography variant="subtitle1">
                  {MESSGAE_IFRAME_LOADER_CONTENT}
                </Typography>
              </Box>
            )}

            <iframe
              id="iframeID"
              allow="camera"
              frameborder="0"
              seamless
              src={iframeSrc}
              height="100%"
              width="98.9%"
              wmode="transparent"
              onLoad={() => setLoading(false)}
              style={{ display: "block" }}
            ></iframe>
          </Box>
        </Box>
      </Box>
    </Dialog>
  );
};

export default withStyles(useStyles, { withTheme: true })(ProductCalculator);
